import {signupContinuationPath} from '../../src/signup-route';
import {APP_BASE} from '../router';
import type {Session} from './types';

/** The server owns admission and the saved choice; a URL alone never grants access. */
export function onboardingDestination(session: Session, returnPath?: string): string {
  return signupContinuationPath(session.onboarding.planId, returnPath, APP_BASE);
}
